<template>
	<Dialog
		:title="reason === 'owner' ? 'Cognito Pay' : 'Verify Your Identity'"
		:visible="internalVisible"
		custom-class="dialog--narrow"
		@closed="handleClosed"
	>
		<template v-if="reason === 'mfa'">
			<EnhancedSecurityGate
				:action-description="' to set up a Cognito Pay account'"
				component-type="div"
				:is-creating-cognito-pay-account="!hasIncompleteAccount"
				@gate-cleared="handleGateCleared"
			/>
		</template>
		<template v-else>
			{{ ownerText }}
		</template>
		<template #footer>
			<button class="button button--primary" @click="handleClosed">Close</button>
		</template>
	</Dialog>
</template>

<script lang="ts">
	import { defineComponent, ref, watch, computed, type PropType } from 'vue';
	import Dialog from 'src/components/dialogs/Dialog.vue';
	import EnhancedSecurityGate from 'src/views/auth/EnhancedSecurityGate.vue';

	export type CognitoPayRequirementReason = 'owner' | 'mfa';

	export default defineComponent({
		name: 'CognitoPayRequirementDialog',
		components: {
			Dialog,
			EnhancedSecurityGate
		},
		props: {
			isVisible: { type: Boolean, default: false },
			reason: { type: String as PropType<CognitoPayRequirementReason>, default: 'owner' },
			hasIncompleteAccount: { type: Boolean, default: false }
		},
		emits: ['closed', 'verified'],
		setup(props, { emit }) {
			const internalVisible = ref(props.isVisible);

			const ownerText = computed(() => {
				return props.hasIncompleteAccount ? 'Contact your organization\'s owner to complete the Cognito Pay onboarding process.'
					: 'Contact your organization\'s owner to get started with Cognito Pay.';
			});

			watch(() => props.isVisible, (val) => { internalVisible.value = val; });

			const handleClosed = () => {
				internalVisible.value = false;
				emit('closed');
			};

			const handleGateCleared = () => {
				handleClosed();
				emit('verified');
			};

			return {
				internalVisible,
				ownerText,
				handleClosed,
				handleGateCleared
			};
		}
	});
</script>
